import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import Anchor from "../elements/Anchor";

import "../../styles/components/slices/common_questions.scss";

const CommonQuestions = ({ slice }) => {
  if (!slice) return null;
  const data = { ...slice };

  return (
    <Container fluid className="common-questions">
      <Container className="max-container py-5">
        <Row className="justify-content-center">
          <Col
            md={8}
            className="align-self-center text-center text-md-end order-2 order-md-1"
          >
            <h4 className="mb-2 title">{data.primary.title1.text}</h4>
            <div className="descr mb-4">
              <PrismicRichText field={data.primary.description.richText} />
            </div>
            <div className="book-now-outline mb-2 mb-md-0 mona">
              <Anchor
                href={data.primary.button_link.url}
                className="book-now-btn text-center mona"
              >
                {data.primary.button_label}
              </Anchor>
            </div>
          </Col>
          <Col
            md={4}
            className="align-self-center text-center text-md-start order-1 order-md-2"
          >
            <GatsbyImage
              image={data.primary.image.gatsbyImageData}
              alt={data.primary.image.alt}
              style={{ width: "280px" }}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default CommonQuestions;
